import { GoogleTagManager } from '@iwoca/frontend-tracking-library';
import _ from 'lodash';
import { put, take, takeLatest, select } from 'redux-saga/effects';

export function* requestALoginLinkWorker() {
    yield takeLatest('REQUEST_LOGIN_LINK', function* () {
        const email = yield select((state) => {
            const people = _.get(
                state,
                'lendingAPI.customer_state.data.application.people',
                []
            );

            const applicant = _.find(people, (person) =>
                _.includes(person.roles, 'applicant')
            );

            return _.get(applicant, 'email', null);
        });

        yield put({
            type: 'api/POST_REQUEST_LOGIN_LINK',
            body: JSON.stringify({ data: { email } })
        });
        const nextAction = yield take([
            'api/POST_REQUEST_LOGIN_LINK [success]',
            'api/POST_REQUEST_LOGIN_LINK [fail]'
        ]);

        if (nextAction.type === 'api/POST_REQUEST_LOGIN_LINK [success]') {
            GoogleTagManager.trackClick({
                identifier: 'Request login link - BusinessAccounts'
            });
        }

        if (nextAction.type === 'api/POST_REQUEST_LOGIN_LINK [fail]') {
            GoogleTagManager.trackError({
                identifier: 'Failed to request login link - BusinessAccounts'
            });
        }
    });
}
